import { stripNonAlphanumeric } from "../../utils/tickets";

/*
 * Title and description rules, the same in every request modal. Spaces and
 * punctuation do not count, so "....." is not a title.
 */
export const TITLE_MIN_CHARS = 5;
export const DESCRIPTION_MIN_CHARS = 10;

export const TITLE_HINT = `At least ${TITLE_MIN_CHARS} letters or numbers.`;
export const DESCRIPTION_HINT = `At least ${DESCRIPTION_MIN_CHARS} letters or numbers.`;

export const isTitleValid = (title: string) =>
  stripNonAlphanumeric(title).length >= TITLE_MIN_CHARS;

export const isDescriptionValid = (description: string) =>
  stripNonAlphanumeric(description).length >= DESCRIPTION_MIN_CHARS;

/** The hint turned into an error, once something was typed and it fails. */
export const titleError = (title: string) =>
  title.trim() && !isTitleValid(title) ? TITLE_HINT : null;

export const descriptionError = (description: string) =>
  description.trim() && !isDescriptionValid(description)
    ? DESCRIPTION_HINT
    : null;
